fragment EmailSyncStatusBanner on EmailSyncStatusBanner {
    status
    title
    description
    error
    initialSyncDescription
    initialSyncDescriptionIsError
    lastSyncTime
    lastEmail {
        subject
        htmlUrl
    }
}
